<template lang="pug">
  header.header(v-if='header')
    button.header__button(:title="value" @click="volumeOff()")
        SvgIcon.header__button-icon.header__button-icon--on.header__button-icon--active(name="volume-on" width="20" height="20")
        SvgIcon.header__button-icon.header__button-icon--off(name="volume-off" width="20" height="20")
    .page__wr
        .header__top
          .header__top-left
            router-link(to="/#")
                img.header__logo(src="@/assets/img/logo.svg" alt="РПК")
          .header__top-right
              form.header__top-right-search(autocomplete="off" v-if="windowWidth > 760")
                  .header__top-right-search-input-wr
                      SvgIcon.header__top-right-search-icon(name="search" width="20" height="29")
                      input.header__top-right-search-input(type="text" name='search' :value="inputStr" @input="evt=>inputStr=evt.target.value")
                      div(v-on:click="closeWindowSearch()")
                          SvgIcon.header__top-right-search-icon.header__top-right-search-icon--close(name="close" width="20" height="20")
                  .header__top-right-search-response.header__top-right-search-response--hide
                      .header__top-right-search-response-loader(:class='{"header__top-right-search-response-loader--show": searchPreloader}')
                          .header__top-right-search-response-loader-item
                          .header__top-right-search-response-loader-item
                          .header__top-right-search-response-loader-item
                      .header__top-right-search-response-no-result
                          p.header__top-right-search-response-no-result-text(:class='{"header__top-right-search-response-no-result-text--hide": noResult}') По вашему запросу ничего не найдено
                      .header__top-right-search-response-scrollbar.header__top-right-search-response-scrollbar--hide
                          .header__top-right-search-response-item(v-for='(item, index) in dataSearch' v-bind:key='index' v-on:click='followingALink($event)')
                              h4.header__top-right-search-response-item-headline {{ item.title }}
                              router-link.header__top-right-search-response-item-link(:to="item.link") {{ item.link }}
                              p.header__top-right-search-response-item-description {{ item.description }}
              .header__top-right-address
                div.header__top-right-address-text(v-for="item in header.address" v-html="item.text")
              .header__top-right-phone
                a.header__top-right-phone-text(v-for="item in header.phone" :href="item.link") {{ item.title }}
              .header__burger(v-on:click="openMenu()")
                .header__burger-item
                .header__burger-item
                .header__burger-item
              .header__mobile(v-if="windowWidth < 1200")
                  .header__mobile-scrollbar
                      form.header__top-right-search(autocomplete="off" v-if="windowWidth < 760")
                          .header__top-right-search-input-wr
                              SvgIcon.header__top-right-search-icon(name="search" width="20" height="29")
                              input.header__top-right-search-input(type='text' name='search' :value="inputStr" @input="evt=>inputStr=evt.target.value")
                              div(v-on:click="closeWindowSearch()")
                                  SvgIcon.header__top-right-search-icon.header__top-right-search-icon--close(name="close" width="20" height="20")
                          .header__top-right-search-response.header__top-right-search-response--hide
                              .header__top-right-search-response-loader(:class='{"header__top-right-search-response-loader--show": searchPreloader}')
                                  .header__top-right-search-response-loader-item
                                  .header__top-right-search-response-loader-item
                                  .header__top-right-search-response-loader-item
                              .header__top-right-search-response-no-result
                                  p.header__top-right-search-response-no-result-text(:class='{"header__top-right-search-response-no-result-text--hide": noResult}') По вашему запросу ничего не найдено
                              .header__top-right-search-response-scrollbar.header__top-right-search-response-scrollbar--hide
                                  .header__top-right-search-response-item(v-for='(item, index) in dataSearch' v-bind:key='index' v-on:click='followingALink($event)')
                                      h4.header__top-right-search-response-item-headline {{ item.title }}
                                      router-link.header__top-right-search-response-item-link(:to="item.link") {{ item.link }}
                                      p.header__top-right-search-response-item-description {{ item.description }}
                      MenuTop(:items="menuTopItems", :path="path")
                      .header__top-right-address
                          div.header__top-right-address-text(v-for="item in header.address" v-html="item.text")
                      .header__top-right-phone
                          a.header__top-right-phone-text(v-for="item in header.phone" :href="item.link") {{ item.title }}

        .header__bottom
          MenuTop(:items="menuTopItems", :path="path")
    Preloader
</template>

<script>
  import '@/components/common/header/header.styl';

  import EventBus from '@/eventBus';

  //import {PopupHelpersVue} from '@/mixins/PopupHelpersVue';
  import {FormHelpersVue} from '@/mixins/FormHelpersVue';
  import {SlideHelpers} from '@/mixins/SlideHelpers';

  import MenuTop from '@/components/common/menuTop/menuTop.vue';
  import SvgIcon from '@/components/common/svgIcon/SvgIcon.vue';
  import Preloader from '@/components/common/preloader/Preloader.vue';

  import 'perfect-scrollbar/css/perfect-scrollbar.css';
  import PerfectScrollbar from 'perfect-scrollbar';

  export default {
    name: 'Header',

    mixins: [FormHelpersVue, SlideHelpers],

    data() {
      return {
        header: null,
        menuTopItems: [],
        path: '',
        search: null,
        dataSearch: [],
        scrollbar: null,
        firstSearch: true,
        windowSizeVue: null,
        inputStr: '',
        searchPreloader: false,
        noResult: true,
        lastValue: '',
        value: 'Отключить звук',
        audioPlay: true,
        windowWidth: 0,
      }
    },

    components: {
      MenuTop,
      SvgIcon,
      Preloader
    },

    watch: {
        inputStr: function() {
            this.search();
            this.startSearch();
        }
    },

    created() {
      EventBus.$on('pageLoaded', res => {
          if(!this.header && this.menuTopItems.length === 0) {
              this.header = res.header;
              this.menuTopItems = res.menuTop;
              this.windowWidth = $(window).width();
              this.$nextTick(() => {
                  if(this.windowWidth < 1200) {
                      this.menuScrollInit();
                  }
              });
          }
      });

      EventBus.$on('setMenuTopActiveClass', path => {
        this.path = path;
      });

      this.search = this.debounce(this.request, 500);
    },

    mounted() {
        $(document).on('click', (event) => { // событие клика по веб-документу
            var div = $(".header__top-right-search"); // тут указываем ID элемента
            if (!div.is(event.target) // если клик был не по нашему блоку
                && div.has(event.target).length === 0) { // и не по его дочерним элементам
                $('.header__top-right-search-response').addClass('header__top-right-search-response--hide'); // скрываем его
            }
        });
    },

    methods: {
        request() {
            if (this.inputStr !== '') {
                let data = {
                    params: this.inputStr
                };

                this.submitForm('Common:searchOnPage', data, res => {
                    if (res.status === 'ok') {
                        this.dataSearch = {};
                        this.dataSearch = res.data;
                        this.searchPreloader = false;
                        if (this.firstSearch === true) {
                            this.scrollInit();
                            this.firstSearch = false;
                        } else {
                            this.scrollbar.update();
                        }
                        setTimeout(() => {
                            $('.header__top-right-search-response-scrollbar').removeClass('header__top-right-search-response-scrollbar--hide');
                        }, 200);
                    } else {
                        this.searchPreloader = false;
                        $('.header__top-right-search-response-no-result').css('display', 'block');
                        setTimeout(() => {
                            this.noResult = false;
                        }, 200);
                    }
                });
            }
        },

        startSearch() {
            this.noResult = true;
            $('.header__top-right-search-response-no-result').css('display', 'none');
            $('.header__top-right-search-response-scrollbar').addClass('header__top-right-search-response-scrollbar--hide');
            if(this.inputStr === '') {
                this.searchPreloader = false;
                this.closeWindowSearch();
                setTimeout(() => {
                    $('.header__top-right-search-response-loader').css('display', 'none');
                }, 200)
            } else {
                this.searchPreloader = true;
                this.openWindowSearch();
                setTimeout(() => {
                    $('.header__top-right-search-response-loader').css('display', 'flex');
                }, 200)
            }
        },

        openWindowSearch() {
            $('.header__top-right-search-response').removeClass('header__top-right-search-response--hide');
            $('.header__top-right-search-icon--close').addClass('header__top-right-search-icon--close--show');
        },

        closeWindowSearch() {
            $('.header__top-right-search-response').addClass('header__top-right-search-response--hide');
            $('.header__top-right-search-icon--close').removeClass('header__top-right-search-icon--close--show');
            this.inputStr = '';
        },

        scrollInit() {
            if($('.header__top-right-search-response-scrollbar').length) {
                this.scrollbar = new PerfectScrollbar('.header__top-right-search-response-scrollbar', {
                    wheelSpeed: 2,
                    wheelPropagation: true,
                    minScrollbarLength: 20
                });
            }
        },

        menuScrollInit() {
            if($('.header__mobile-scrollbar').length) {
                let ps = new PerfectScrollbar('.header__mobile-scrollbar', {
                    wheelSpeed: 2,
                    wheelPropagation: true,
                    minScrollbarLength: 20
                });
            }
        },

        followingALink(event) {
            let element = event.target;

            let link = $(element).find('.header__top-right-search-response-item-link').attr('href');
            window.open(link, '_blank');
        },

        volumeOff() {
            $('.header__button-icon').removeClass('header__button-icon--active');
            if(this.audioPlay) {
                this.audioPlay = false;
                EventBus.$emit('audioVolumeOff');
                $('.header__button-icon--off').addClass('header__button-icon--active');
                this.value = 'Включить звук';
            } else {
                this.audioPlay = true;
                EventBus.$emit('audioVolumeOn');
                $('.header__button-icon--on').addClass('header__button-icon--active');
                this.value = 'Отключить звук';
            }
        },

        openMenu() {
            if($('.header__burger').hasClass('header__burger--open')) {
                $('.header__burger').removeClass('header__burger--open');
                $('.header__mobile').removeClass('header__mobile--show');
                setTimeout(() => {
                    $('.header').removeClass('header--height');
                }, 200);
            } else {
                $('.header__burger').addClass('header__burger--open');
                $('.header').addClass('header--height');
                setTimeout(() => {
                    $('.header__mobile').addClass('header__mobile--show');
                }, 200);
            }
        },

        debounce(func, wait, immediate) {
            var timeout, args, context, timestamp, result;
            if(null == wait) wait = 100;

            function later() {
                var last = Date.now() - timestamp;

                if(last < wait && last >= 0) {
                    timeout = setTimeout(later, wait - last);
                }
                else {
                    timeout = null;
                    if(!immediate) {
                        result  = func.apply(context, args);
                        context = args = null;
                    }
                }
            };

            var debounced = function() {
                context     = this;
                args        = arguments;
                timestamp   = Date.now();
                var callNow = immediate && !timeout;
                if(!timeout) timeout = setTimeout(later, wait);
                if(callNow) {
                    result  = func.apply(context, args);
                    context = args = null;
                }

                return result;
            };

            debounced.clear = function() {
                if(timeout) {
                    clearTimeout(timeout);
                    timeout = null;
                }
            };

            debounced.flush = function() {
                if(timeout) {
                    result  = func.apply(context, args);
                    context = args = null;

                    clearTimeout(timeout);
                    timeout = null;
                }
            };

            return debounced;
        }
    }

  }
</script>
